var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-container"},_vm._l((_vm.stepOptions),function(option,index){return _c('div',{key:option.id,staticClass:"nav-container__step"},[_c('div',{staticClass:"qn-header-container"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('span',{staticClass:"fa-stack qn-header-container__icon-container cursor-pointer"},[_c('em',{staticClass:"fas fa-circle fa-stack-2x",class:{
              'qn-header-container--active': option.active,
              'qn-header-container--completed': option.completed,
              'qn-header-container--disabled':
                !option.active && !option.completed,
            }}),_c('span',{staticClass:"fa-stack-1x",class:{
              'text-white': option.active,
              'color-gray-19': !option.active && !option.completed,
            }},[(option.completed)?_c('em',{staticClass:"fas fa-check text-white"}):_c('b',[_vm._v(_vm._s(index + 1))])])]),_c('span',{staticClass:"font-14 font-weight-bold qn-header-container__title pr-4 border-bottom",class:{
            'qn-header-container__title--active': option.active,
            'qn-header-container__title--completed': option.completed,
            'qn-header-container__title--disabled':
              !option.active && !option.completed,
          }},[_c('span',[_vm._v(_vm._s(option.title))])])])])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }